import Swal from "sweetalert2";
//advertencias
export const advertenciaEliminar = async (titulo, texto) => {
	const result = await Swal.fire({
		title: titulo,
		text: texto,
		icon: "warning",
		showCancelButton: true,
		confirmButtonColor: "var(--principal)",
		cancelButtonColor: "var(--secundario)",
		confirmButtonText: "¡Sí, eliminar!",
		cancelButtonText: "Cancelar",
	});

	return result.isConfirmed; // Devuelve `true` si el usuario confirmó
};

export const advertenciaConfirmar = async (titulo, texto) => {
	const result = await Swal.fire({
		title: titulo,
		text: texto,
		icon: "warning",
		showCancelButton: true,
		confirmButtonColor: "var(--principal)",
		cancelButtonColor: "var(--secundario)",
		confirmButtonText: "¡Sí!",
		cancelButtonText: "Cancelar",
	});

	return result.isConfirmed; // Devuelve `true` si el usuario confirmó
};

export const solicitarValor = async (titulo, texto, placeholder, valor = "", iva = false, comentario = "") => {
    const { value } = await Swal.fire({
        title: titulo,
        html: `
            <p>${texto}</p>
            <input id="swal-input-precio" type="number" step="0.01" min="0" class="swal2-input" placeholder="${placeholder}" value="${valor}">
            <div style="text-align: left; margin-top: 10px;">
                <input type="checkbox" id="swal-checkbox-iva" ${iva ? "checked" : ""}>
                <label for="swal-checkbox-iva"> Aplicar IVA</label>
            </div>
            <textarea id="swal-textarea-comentario" class="swal2-textarea" placeholder="Añadir comentario...">${comentario}</textarea>
        `,
        showCancelButton: true,
        confirmButtonColor: "var(--principal)",
        cancelButtonColor: "var(--secundario)",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
            const precio = document.getElementById("swal-input-precio").value;
            const aplicarIVA = document.getElementById("swal-checkbox-iva").checked;
            const comentarioTexto = document.getElementById("swal-textarea-comentario").value;

            if ((!precio || isNaN(precio) || parseFloat(precio) <= 0) && !comentarioTexto) {
                Swal.showValidationMessage("Por favor, ingresa un precio válido o un comentario.");
                return false;
            }
            return {
                precio: precio ? parseFloat(precio).toFixed(2) : null,
                aplicarIVA,
                comentario: comentarioTexto
            };
        }
    });

    return value || undefined;
};
